import { render, staticRenderFns } from "./item8.vue?vue&type=template&id=1b946498&scoped=true"
import script from "./item8.vue?vue&type=script&lang=js"
export * from "./item8.vue?vue&type=script&lang=js"
import style0 from "./item8.vue?vue&type=style&index=0&id=1b946498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b946498",
  null
  
)

export default component.exports